import { message } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { useCallback, useEffect, useState } from 'react';
import { HelpdeskHttp } from '@/services';
import { useUserContext } from '@/context';
import { AppButton, PageContainer } from '@/components';
import { HelpdeskIssuePage } from '@/components/helpdesk';
import { useModal, useDevice } from '@/hooks';

const HelpdeskIssueDetailsPage = () => {
  const { profile } = useUserContext();
  const [t] = useTranslation(['common', 'helpdesk']);

  const params = useParams();
  const issueId = params['issueId'];

  const navigate = useNavigate();
  const addNoteModal = useModal();
  const closeIssueModal = useModal();
  const cancelIssueModal = useModal();
  const { isDesktop } = useDevice();
  const [issue, setIssue] = useState<any>();
  const [error, _setError] = useState('');
  const [loading, setLoading] = useState(true);

  const fetchIssue = useCallback(async () => {
    setLoading(true);
    const id = Number(issueId);
    if (Number.isNaN(id)) {
      message.error({ content: t('common:errors.page-not-found') });
      return navigate('/');
    }
    HelpdeskHttp
      .getIssueById(id, profile?.saminKey)
      .then(res => setIssue(res.issue))
      .catch(() => t('common:errors.page-not-found'))
      .finally(() => setLoading(false));
  }, [issueId, profile?.saminKey, setLoading, navigate, t]);

  useEffect(() => {
    fetchIssue();
  }, []);

  const sideButton = isDesktop() ? '' : (
    <>
      {issue ? issue?.author?.id === issue?.assigned_to?.id ?
        <AppButton
          ghost
          appVariant="cancel-gray"
          onClick={closeIssueModal.show}
          className="!border-transparent px-2 !bg-transparent !shadow-none">
          {t('helpdesk:labels.close-request')}
        </AppButton> :
        <AppButton
          ghost
          danger
          onClick={cancelIssueModal.show}
          className="!border-transparent px-2 !bg-transparent !shadow-none"
        >
          {t('helpdesk:labels.cancel-request')}
        </AppButton> : ''
      }
    </>
  );

  return (
    <PageContainer
      sideButton={sideButton}
      title={t('common:features.view-request')}>
      <HelpdeskIssuePage
        loading={loading}
        error={error}
        issue={issue}
        retry={fetchIssue}
        addNoteModal={addNoteModal}
        closeIssueModal={closeIssueModal}
        cancelIssueModal={cancelIssueModal}
      />
    </PageContainer>
  );
};

export default HelpdeskIssueDetailsPage;
